module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/pictogram-search-fe82a4312337ee7fd1f36c129d32bc21.svg";